module.exports = __webpack_public_path__ + "static/img/background-1121.3b041e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background-1121.jpg
// module id = aau2
// module chunks = 1